import OrderItems from './lineItems/OrderItems'
import Payment from './payment/Payment'
import {Errors} from 'app/features/orders/fulfillments/components'
import {RootState} from 'setup'
import {
  selectOrderErrors,
  selectOrderProcessErrors,
} from 'app/features/orders/redux/order/orderEditSlice'
import {useSelector} from 'react-redux'

export const OrderEditProductsWrapper = () => {
  const errors = useSelector<RootState, any[]>(selectOrderErrors)
  const orderProcessErrors = useSelector<RootState, any[]>(selectOrderProcessErrors)
  return (
    <div className='row gy-5 g-xl-8'>
      <div className='col-xl-8'>
        <OrderItems />
      </div>
      <div className='col-xl-4'>
        <Payment />
        <Errors errors={errors} />
        <Errors errors={orderProcessErrors} isShowOnlyError />
      </div>
    </div>
  )
}

export default OrderEditProductsWrapper
